import { Component, Input } from '@angular/core';

export interface MapToolbarZoneButton {
    text: string;
    action: () => void;
}

export interface MapToolbarZone {
    key: string;
    title?: string;
    description?: string;
    buttons: MapToolbarZoneButton[];
}

@Component({
    selector: 'key-map-toolbar-zones',
    templateUrl: './map-toolbar-zones.component.html',
})
export class MapToolbarZonesComponent {
    @Input() show: {
        zoneaddpolyline: boolean;
        zoneaddpolygon: boolean;
        zoneedit: boolean;
        zonedelete: boolean;
    };
    @Input() items: MapToolbarZone[];
}
